export const ENV_TYPES = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production',
  QA: 'qa'
};

export const currentEnv = process.env.REACT_APP_NODE_ENV || ENV_TYPES.DEVELOPMENT;

const API_URLS = {
  [ENV_TYPES.PRODUCTION]: "https://api.neusort.com/",
  [ENV_TYPES.STAGING]: "https://api.staging.neusort.com/",
  [ENV_TYPES.DEVELOPMENT]: "http://localhost:5005/",
  [ENV_TYPES.QA]: "http://20.40.47.123:8080/"
};

const EVAL_CLIENT_URLS = {
  [ENV_TYPES.PRODUCTION]: "https://evalai.neusort.com/",
  [ENV_TYPES.STAGING]: "https://evalai.staging.neusort.com/",
  [ENV_TYPES.DEVELOPMENT]: "http://localhost:3000/",
  [ENV_TYPES.QA]: "http://20.40.47.123:3000/"
};

const COMPANY_IDS = {
  [ENV_TYPES.PRODUCTION]: "tdb8c32bde588491",
  [ENV_TYPES.STAGING]: "tdb8c32bde588491",
  [ENV_TYPES.DEVELOPMENT]: "nbbeab6f1584da58",
  [ENV_TYPES.QA]: "tdb8c32bde588491"
};

const INVITE_IDS = {
  [ENV_TYPES.PRODUCTION]: "45117325-552c-438f-9c27-440ae473d240",
  [ENV_TYPES.STAGING]: "45117325-552c-438f-9c27-440ae473d240",
  [ENV_TYPES.DEVELOPMENT]: "ce57c194-d590-45bd-8a41-52f3cf763d6d",
  [ENV_TYPES.QA]: "45117325-552c-438f-9c27-440ae473d240"
};

const RAZORPAY_KEYS = {
  [ENV_TYPES.PRODUCTION]: "rzp_live_K5a0N6bOmYFW7O",
  [ENV_TYPES.STAGING]: "rzp_live_K5a0N6bOmYFW7O",
  [ENV_TYPES.DEVELOPMENT]: "rzp_test_oDrMzpIYkooNTt",
  [ENV_TYPES.QA]: "rzp_test_oDrMzpIYkooNTt"
};

const B2C_RAZORPAY_KEYS = {
  [ENV_TYPES.PRODUCTION]: "rzp_live_3awdguwmCGNWyn",
  [ENV_TYPES.STAGING]: "rzp_live_3awdguwmCGNWyn",
  [ENV_TYPES.DEVELOPMENT]: "rzp_test_oDrMzpIYkooNTt",
  [ENV_TYPES.QA]: "rzp_test_oDrMzpIYkooNTt"
};

export const EVAL_CLIENT_URL = EVAL_CLIENT_URLS[currentEnv];

export const BASE_URL = API_URLS[currentEnv];

export const HOST_NAMES = ["neusort.com", "hyrr.app", "techyrr.com", "localhost", "azurecontainerapps.io"];

export const TEST_IPS = ["20.193.143.183", "20.197.39.7", "20.40.47.123", "20.198.57.161"];

export const adminViewAssignmentDir = "/opt/admin/assignments/";

export const licenceTypes = {
  v1: "Ultra",
  v2: "Pro",
  v4: "Spark",
  v5: "Vertex",
};

export const techyrrCompanyId = COMPANY_IDS[currentEnv];

export const techyrrInviteId = INVITE_IDS[currentEnv];

export const products = [
  {
    title: "EvalAI",
    href: "https://neusort.com/product/eval-ai",
    description: "AI Interviews",
  },
];

export const PUBLIC_RAZORPAY_API_KEY = RAZORPAY_KEYS[currentEnv];

export const PUBLIC_B2C_RAZORPAY_API_KEY = B2C_RAZORPAY_KEYS[currentEnv];

export const restrictedDomains = [
  "mail.com",
  "gmail.com",
  "hotmail.com",
  "yahoo.com",
  "outlook.com",
  "icloud.com",
  "aol.com",
  "zoho.com",
  "protonmail.com",
  "yandex.com",
  "live.com",
  "me.com",
  "msn.com",
  "gmx.com",
  "inbox.com",
];

export const b2cTechyrrDomains = ["www.techyrr.com", "techyrr.com"];

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const maxAllowedSkillsMap = {
  v1: 10,
  v2: 10,
  v3: 10,
  v4: 10,
  v5: 2,
}